import React, {useEffect, useState} from "react";
import CardTeam from "../../../../../../components/Molecules/Cards/Teams/CardTeam";
import DirRespService from "../../../../../../services/Ing/DirResp/DirRespService";


const HomeIngManTeams = ({teams, timeToRealod}) => {

	const [roleExtra, setRoleExtra] = useState([]);
	const [roleDiagnostic, setRoleDiagnostic] = useState([]);
	const [roleManager, setRoleManager] = useState([]);
	const [roleVerificateur, setRoleVerificateur] = useState([]);
	const [roleChargeAffaire, setRoleChargeAffaire] = useState([]);

	const getVerificateur = async () => {
		const request = await DirRespService.getUsersByRole({roles: "ROLE_ING_VERIF"})
		if (request.request.status === 200) {
			setRoleVerificateur(request.data["hydra:member"])
		}
	}

	const getManager = async () => {
		const request = await DirRespService.getUsersByRole({roles: "ROLE_ING_MANAGER"})
		if (request.request.status === 200) {
			setRoleManager(request.data["hydra:member"])
		}
	}

	const getDiagnostic = async () => {
		const request = await DirRespService.getUsersByRole({roles: "ROLE_ING_DIAG"})
		if (request.request.status === 200) {
			setRoleDiagnostic(request.data["hydra:member"])
		}
	}

	const getExtra = async () => {
		const request = await DirRespService.getUsersByRole({roles: "ROLE_ING_EXTRA"})
		if (request.request.status === 200) {
			setRoleExtra(request.data["hydra:member"])
		}
	}

	const getAffaire = async () => {
		const request = await DirRespService.getUsersByRole({roles: "ROLE_ING_AFF"})
		if (request.request.status === 200) {
			setRoleChargeAffaire(request.data["hydra:member"])
		}
	}

	useEffect(() => {
		getManager()
		getVerificateur()
		getDiagnostic()
		getExtra()
		getAffaire()
	}, []);

	return (
		<div className="projects-in-progress">
			<h3 className="color-primary">Tâches à attribuer</h3>
			<div className="projects-in-progress-container projects-in-progress-engineer-tasks">
				{teams.map((team, index) => {
						return (
							<CardTeam
								key={index}
								team={team}
								manager={roleManager}
								verificateur={roleVerificateur}
								diagnostic={roleDiagnostic}
								extra={roleExtra}
								affaire={roleChargeAffaire}
								timeToRealod={timeToRealod}
							/>
						)
					}
				)}
			</div>
		</div>
	)
}

export default HomeIngManTeams;
